import { render, staticRenderFns } from "./Captcha.vue.html?vue&type=template&id=02c0d023&lang=html&external"
import script from "./Captcha.vue.js?vue&type=script&lang=js&external"
export * from "./Captcha.vue.js?vue&type=script&lang=js&external"
import style0 from "./Captcha.vue.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports